import * as ngCore from '@angular/core'

/**
 * Inline mutation error shown inside Admin Center dialogs.
 */
@ngCore.Component({
  selector: 'atn-admin-error-message',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** User-facing error message to display. */
  public readonly messageSg = ngCore.input<string | undefined>(undefined, {
    alias: 'message',
  })
}
